import { render, staticRenderFns } from "./BuyBusinessAdd.vue?vue&type=template&id=8f22670a&scoped=true&"
import script from "./BuyBusinessAdd.vue?vue&type=script&lang=js&"
export * from "./BuyBusinessAdd.vue?vue&type=script&lang=js&"
import style0 from "./BuyBusinessAdd.vue?vue&type=style&index=0&id=8f22670a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f22670a",
  null
  
)

export default component.exports